import md from "util/markdownRenderer";
export function Markdown({ markdownText }: { markdownText: string }) {
    const renderedHeader = md.render(markdownText, "");
    return (
        <div
            className="Markdown"
            dangerouslySetInnerHTML={{ __html: renderedHeader }}
        />
    );
}

export function MarkdownInline({
    markdownInlineText,
}: {
    markdownInlineText: string;
}) {
    const renderedHeader = md.renderInline(markdownInlineText, "");
    return (
        <span
            className="MarkdownInline"
            dangerouslySetInnerHTML={{ __html: renderedHeader }}
        />
    );
}
